import React, { Component } from "react";
import cta1 from "../assets/images/cta-1.jpg";
class CallToActionThree extends Component {
  render() {
    return (
      <section className="cta-three">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 clearfix">
              <img src={cta1} className="cta-three__image" alt="" />
            </div>
            <div className="col-lg-6">
              <div className="cta-three__content">
                <div className="block-title text-left">
                  <h2 className="block-title__title">
                  将最好的器械 
                  <br />
                  部署在每一个医院
                  </h2>
                </div>
                <p className="cta-three__text">
                苏州卫捷长期专注于PIVAS新产品研发和设备升级,引领了静脉用药调配中心的智能化发展,是业界少有的能提供PIVAS整体规划方案、整体装修、核心设备安装、辅助设备调试、PIVAS整体运作流程的信息记录及追溯等综合解决方案的企业。
                </p>
                <div className="cta-three__single-wrap">
                  <div className="cta-three__single">
                    <i className="kipso-icon-strategy"></i>
                    <p className="cta-three__single-text">
                    极速器械部署
                    </p>
                  </div>
                  <div className="cta-three__single">
                    <i className="kipso-icon-training"></i>
                    <p className="cta-three__single-text">远程服务响应</p>
                  </div>

                  <div className="cta-three__single">
                    <i className="kipso-icon-human-resources"></i>
                    <p className="cta-three__single-text">定期硬件巡查</p>
                  </div>
                </div>
                {/* <a href="#none" className="thm-btn">
                  了解更多
                </a> */}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default CallToActionThree;
